import type { UiMeta } from './uiMeta';
import { getUiMeta } from './uiMeta';

export type BulkRunStatusValue = 'PENDING' | 'PROCESSING' | 'COMPLETED';
export type BulkDetailStatusValue = 'OK' | 'DUPLICATE' | 'ALREADY_EXIST' | 'INVALID';

export type BulkRunStatusOptions = {
  isDeleted?: boolean;
  labelCase?: 'default' | 'upper';
};

export const BULK_RUN_STATUS_META = {
  PENDING: {
    label: 'Pending',
    chip: { color: 'warning', variant: 'filled' },
    order: 1,
  },
  PROCESSING: {
    label: 'Processing',
    chip: { color: 'primary', variant: 'outlined' },
    order: 2,
  },
  COMPLETED: {
    label: 'Completed',
    chip: { color: 'success', variant: 'filled' },
    order: 3,
  },
} as const satisfies Record<BulkRunStatusValue, UiMeta>;

export const BULK_DETAIL_STATUS_META = {
  OK: {
    label: 'OK',
    chip: { color: 'primary', variant: 'outlined' },
    order: 1,
  },
  DUPLICATE: {
    label: 'DUPLICATE',
    chip: { color: 'warning', variant: 'filled' },
    order: 2,
  },
  ALREADY_EXIST: {
    label: 'ALREADY EXIST',
    chip: { color: 'error', variant: 'filled' },
    order: 3,
  },
  INVALID: {
    label: 'INVALID',
    chip: { color: 'error', variant: 'filled' },
    order: 4,
  },
} as const satisfies Record<BulkDetailStatusValue, UiMeta>;

export const getBulkRunStatusMeta = (
  status?: BulkRunStatusValue | string | null,
  options: BulkRunStatusOptions = {},
): UiMeta => {
  if (options.isDeleted) {
    return {
      label: 'Deleted',
      chip: { color: 'default', variant: 'filled' },
    };
  }

  const isKnownStatus = Boolean(
    status && status in BULK_RUN_STATUS_META,
  );
  const meta = getUiMeta(BULK_RUN_STATUS_META, status);

  return {
    ...meta,
    label:
      options.labelCase === 'upper' && isKnownStatus
        ? meta.label.toUpperCase()
        : meta.label,
  };
};

export const getBulkDetailStatusMeta = (
  status?: BulkDetailStatusValue | string | null,
): UiMeta => getUiMeta(BULK_DETAIL_STATUS_META, status);
